import React, { useContext } from "react";
import {
  SpreadsheetContext,
} from "@gistapps/composite-spreadsheet";
import type {
  DataEditorProps,
} from "@gistapps/composite-spreadsheet";

const DateTimeCellEditor = ({
  cell,
  column,
  row,
  exitEditMode,
}: DataEditorProps) => {

  console.log("Rendering DateTimeCellEditor with value:", cell?.value);

  const {
    updateSpreadsheetCellData,
  } = useContext(SpreadsheetContext);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    updateSpreadsheetCellData(row, column, { value: e.target.value }, true);
  };

  return (
    <input
      type="datetime-local"
      className="gc__table-datetime-editor"
      defaultValue={(cell?.value as string) ?? ""}
      onChange={handleChange}
      autoFocus
    />
  );

};

export default DateTimeCellEditor;
